module.exports = __webpack_public_path__ + "img/play.10d8090.svg";